module.exports = __webpack_public_path__ + "static/media/heinz-national-wildlife-refuge.96139975.md";